import { 
    BsReverseListColumnsReverse, 
    BsHash,
    BsTelephoneFill,
    BsFillCalendar2CheckFill,
    BsLink45Deg,
    BsEnvelopeFill,
    BsFileEarmarkText,
    BsListNested,
    BsPersonPlusFill,
    BsBoxes,
} from 'react-icons/bs'
import { SubPropertyProps, PropertySchema } from "../../layout/table/property/Property.types"

export const PROPERTIES = [
    { icon: BsReverseListColumnsReverse({ size: '12px'}), label: 'Text', tooltipText: 'Click to add text' },
    { label: 'Number', tooltipText: 'Click to add number', icon: BsHash({ size: '12px'}) },
    { label: 'Phone Number', tooltipText: 'Click to add phone number', icon: BsTelephoneFill({ size: '12px'}) },
    { label: 'Date', tooltipText: 'Click to add a date', icon: BsFillCalendar2CheckFill({ size: '12px'}) },
    { label: 'Link', tooltipText: 'Click to add a link', icon: BsLink45Deg({ size: '12px'}) },
    { label: 'Email', tooltipText: 'Click to add an email', icon: BsEnvelopeFill({ size: '12px'}) },
    { label: 'File', tooltipText: 'Click to add a file', icon: BsFileEarmarkText({ size: '12px'}) },
    { label: 'Multi Select', tooltipText: 'Click to select than one option', icon: BsListNested({ size: '12px'}) },
    { label: 'Person', tooltipText: 'Click to add a person', icon: BsPersonPlusFill({ size: '12px'}) },
] as SubPropertyProps[]

export const PROPERTY_LIST: PropertySchema[] = [
    { name: 'Batch No', type: 'Text', label: "Text", isHidden: false, icon: BsHash({ size: '12px'})  },
    { name: 'No of Items',  type: 'Number', label: "Text", isHidden: false, icon: BsBoxes({ size: '12px'})  },
    { name: 'Email Address', type: 'Email', label: "Email", isHidden: false, icon: BsEnvelopeFill({ size: '12px'})  },
    { name: 'Phone Number', type: 'number', label: "Phone Number", isHidden: false, icon: BsTelephoneFill({ size: '12px'})  },
]